export default function ProjectCheckboxDropdown () {
    const el = document.querySelector('.site-form--checkbox-dropdown');
    if (!el) return;

    const trigger = el.querySelector('.site-form--checkbox-dropdown-trigger');
    if (!trigger) return;

    trigger.addEventListener('click', (event) => {
        event.stopPropagation();

        el.classList.toggle('collapsed');
    });
}
